// removed by extract-text-webpack-plugin
module.exports = {"toolbarSkeleton":"styles__toolbarSkeleton___3hU7G","skeletonText":"styles__skeletonText___1RIqb","skeleton":"styles__skeleton___2QwMy","skeleton-loading":"styles__skeleton-loading___1C5qy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Skeleton/ToolbarSkeleton/styles.css
// module id = 2499
// module chunks = 0